// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallFinished__container-f1b035 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.CallFinished__content-bb8bee {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.CallFinished__title-f0c16a {
  color: var(--base-110);
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
}

.CallFinished__sub-title-bfb0b6 {
  color: var(--base-80);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  margin-bottom: 24px;
  text-align: center;
}

.CallFinished__logo-a68340 {
  margin-bottom: 24px;
}

.CallFinished__join-again-button-f0f0c2 {
  width: 100%;
}

@media (max-width: 428px) {
  .CallFinished__container-f1b035 {
    flex-grow: 1;
  }
  .CallFinished__content-bb8bee {
    justify-content: center;
    flex-grow: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/CallFinished/CallFinished.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,2CAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE;IACE,YAAA;EACF;EACA;IACE,uBAAA;IACA,YAAA;EACF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n}\n\n.sub-title {\n  color: var(--base-80);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.logo {\n  margin-bottom: 24px;\n}\n\n.join-again-button {\n  width: 100%;\n}\n\n@media (max-width: 428px) {\n  .container {\n    flex-grow: 1;\n  }\n  .content {\n    justify-content: center;\n    flex-grow: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CallFinished__container-f1b035`,
	"content": `CallFinished__content-bb8bee`,
	"title": `CallFinished__title-f0c16a`,
	"sub-title": `CallFinished__sub-title-bfb0b6`,
	"subTitle": `CallFinished__sub-title-bfb0b6`,
	"logo": `CallFinished__logo-a68340`,
	"join-again-button": `CallFinished__join-again-button-f0f0c2`,
	"joinAgainButton": `CallFinished__join-again-button-f0f0c2`
};
module.exports = ___CSS_LOADER_EXPORT___;
